import { Typography, toast } from "@stardust-ds/react"
import Modal from "../../molecules/Modal"
import intl, { get } from 'react-intl-universal'
import Select from "../../atoms/Select"
import Input from "../../atoms/Input"
import styles from './index.module.scss'
import RcmpSteps from "../../atoms/Steps"
import Button from "../../atoms/Button"
import ArrowLeftIcon from "../../../assets/icons/ArrowLeftIcon"
import ArrowRightIcon from "../../../assets/icons/ArrowRightIcon"
import RcmpActivityField from '../ActivityField'
import { FormProvider, set, useForm, useFormContext } from "react-hook-form"
import { useContext, useEffect, useRef, useState } from "react"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"
import RcmpModalInfo from "../ModalInfo"
import { cDeadLineSlug, cInvolvedsSlug, cResponsiblesSlug, cStatusSlug, dConclusionDateSlug, dCreationDateSlug } from "../../../constans/activity-slugs"
import AuthContext from "../../../contexts/Auth"
import InfoIcon from "../../../assets/icons/InfoIcon"
import { fnFormatDate, fnFormatDateFromUTC, fnFormatDateToUTC } from "../../../utils/date"
import moment, { fn } from "moment"
import { fnGetUsers } from "../../../services/auth"
import useDataApi from "../../../hooks/useDataApi"
import FieldsContext from "../../../contexts/Fields"
import { fnCreateNewAutomation } from "../../../services/automation"
import automationContext from "../../../contexts/Automation"
import { QRCodeCanvas } from "qrcode.react"
import LinkShareIcon from "../../../assets/icons/LinkShareIcon"
import QrCodeIcon from "../../../assets/icons/QrCodeIcon"
import WorkerIcon from "../../../assets/icons/WorkerIcon"
import RcmpTiggerRecurrence from "./triggerRecurrence"
import ConfirCircleIcon from "../../../assets/icons/ConfirCircleIcon"
import RcmpTriggerEvent from "./triggerEvent"
import RcmpAutomationNotification from "./automationNotification"
import { ConsoleView } from "react-device-detect"

const cPrefixFieldName = "activity-field-"


function fnCreateFieldsValitionSchema(aFields, bIsEdit, cUserTimeZone) {
    if (!aFields?.length) return
    //validação do responsável
    const bValidateResponsible = aFields.some(
        (field) => field.opfd_cslug === cResponsiblesSlug
    )

    // Find field id
    const responsibleField = aFields.find(
        (field) => field.opfd_cslug === cResponsiblesSlug
    )


    const nFieldId = responsibleField?.ombf_opfd_nid
        ? responsibleField?.ombf_opfd_nid
        : responsibleField?.opfd_nid
    const cFieldName = `${cPrefixFieldName}${nFieldId}`

    let responsibleSchema = yup.array().of(yup.number())
        .transform((curr, orig) => {
            return orig
        })

    if (bValidateResponsible) {
        responsibleSchema = responsibleSchema
            .min(1, intl.get("form.select_responsibles"))
            .required(intl.get("form.select_responsibles"))
    }

    let fieldsValidations = {}
    if (responsibleField) {
        fieldsValidations[cFieldName] = responsibleSchema
    }

    // Check if status is Done

    aFields?.map((field) => {
        const nFieldId = field?.ombf_opfd_nid
            ? field?.ombf_opfd_nid
            : field?.opfd_nid
        const cFieldName = `${cPrefixFieldName}${nFieldId}`
        const bIsRequiredToCreate =
            field?.ombf_brequired === true

        let bIsRequired = bIsRequiredToCreate

        if (field?.opfd_ctype?.toLowerCase() === "date") {

            return (fieldsValidations[cFieldName] =
                bIsRequired ?
                    yup
                        .date()
                        .nullable()
                        .transform((curr, orig) => {
                            if (!orig || orig?.length == 0) {
                                return null
                            } else {
                                return new Date(
                                    fnFormatDateToUTC(
                                        orig,
                                        cUserTimeZone,
                                        "YYYY-MM-DD[T]HH:mm:ss.SSS"
                                    )
                                )
                            }
                        })
                        .required(intl.get("modal_new_automation.required_field_message"))
                        .typeError(intl.get("form.invalid_date"))
                    : yup
                        .date()
                        .nullable()
                        .transform((curr, orig) => {

                            if (!orig || orig?.length == 0) {
                                return null
                            } else {
                                return new Date(
                                    fnFormatDateToUTC(
                                        orig,
                                        cUserTimeZone,
                                        "YYYY-MM-DD[T]HH:mm:ss.SSS"
                                    )
                                )
                            }
                        })
                        .typeError(intl.get("form.invalid_date")).nullable()
            )
        }

        if (field?.opfd_ctype?.toLowerCase() === "peoples") {

            return (fieldsValidations[cFieldName] = bIsRequired
                ? yup
                    .array()
                    .transform((curr, orig) => {
                        return orig
                    })
                    .min(1, intl.get("modal_new_automation.required_field_message"))
                    .of(yup.number())
                    .required(intl.get("modal_new_automation.required_field_message"))
                    .typeError(intl.get("form.invalid_date"))
                : yup.array().notRequired().nullable())
        }

        if (field?.opfd_ctype?.toLowerCase() === "selection") {
            return (fieldsValidations[cFieldName] = bIsRequired
                ? yup.mixed().required(intl.get("modal_new_automation.required_field_message"))
                : yup.mixed().nullable())
        }

        if (field?.opfd_ctype?.toLowerCase() === "calc") {
            
            return (fieldsValidations[cFieldName] = bIsRequired
                ? yup.object({
                    value: yup.string(),
                    formula: yup.string()
                }).required(intl.get("modal_new_automation.required_field_message"))
                : yup.object({
                    value: yup.string(),
                    formula: yup.string()
                }).nullable()
            )
        }

        return (fieldsValidations[cFieldName] = bIsRequired
            ? yup.string()?.trim()
                .required(intl.get("modal_new_automation.required_field_message"))
                .test('isWhitespace', 'Não é permitido somente espaço em branco.', value => {
                    return !/^\s*$/.test(value)
                })
            : yup.string().test(
                'is-valid',
                intl.get("modal_new_automation.field_blank_spaces"),
                value => value === "" || (value?.trim() !== "" && value !== " ")
            ).nullable()

        )
    })

    return yup.object().shape(fieldsValidations)
}


function RcmpInitialStep(props) {
    const { register, setValue, errors, getValues, fnSetBIsDisabledButton, fnSetCAutomationType, cAutomationType, bIsEditAutomation, bActiveAutomation } = props

    const oAutomationTypeOptions = [{
        label: intl.get("modal_new_automation.activity_trigger"),
        value: "activity_trigger"
    },
    {
        label: intl.get("modal_new_automation.notification_trigger"),
        value: "notification_trigger"
    }
    ]


    function fnSelectedAutomationType(e) {
        if (!e) {
            fnSetBIsDisabledButton?.(true)
            fnSetCAutomationType("")
            return
        }
        if (e.value !== cAutomationType && !bIsEditAutomation) {
            setValue("automationType", e)
            setValue("blockId", undefined)
            setValue("blockEvent", undefined)
        }

        fnSetBIsDisabledButton?.(false)
        fnSetCAutomationType(e.value)

    }

    return (

        <div className={styles.modalContent}>
            <Typography type="l2" color="#415364">{intl.get("modal_new_automation.select_block")}</Typography>
            <div>
                <Input label={`${intl.get("modal_new_automation.automatio_title")}*`} isFullWidth {...register("automationName")} defaultValue={getValues("automationName") || ""} />
                <RcmpFormErrorMessage>{errors.automationName?.message}</RcmpFormErrorMessage>
            </div>
            <div>
                <Select disabled={bActiveAutomation || bIsEditAutomation} options={oAutomationTypeOptions} onSelect={(e) => fnSelectedAutomationType(e)} label={`${intl.get("modal_new_automation.automation_type")}`} defaultValue={getValues("automationType") || ""} placeholder={intl.get("select")} />
                <RcmpFormErrorMessage>{errors.automationType?.value?.message}</RcmpFormErrorMessage>
            </div >

        </div >
    )
}


function RcmpFirstStep(props) {
    const { aBlocks, fnSetOblockSelected, register, setValue, errors, getValues, fnSetBIsDisabledButton, cUserTimezone, aFields, bDeadLineIsRequired, fnSetCRecurrence, watch, reset, nStep, bIsEditAutomation, setError, clearErrors, bActiveAutomation } = props;
    const oAutomationTypeOptions = [
        {
            label: intl.get("modal_new_automation.triggers.recurrence"),
            value: "recurrence",
            id: 0
        },
        {
            label: intl.get("modal_new_automation.triggers.event"),
            value: "event",
            id: 1
        }
    ]

    const [bTiggerSelected, fnSetBTriggerSelected] = useState(getValues("trigger") !== undefined ? getValues("trigger") : undefined)
    const [cEventSelected, fnSetCEventSelected] = useState(getValues("event")?.value || "")

    const aTriggerSelected = {
        recurrence: <RcmpTiggerRecurrence key={0} setValue={setValue} errors={errors} getValues={getValues} cUserTimezone={cUserTimezone} bDeadLineIsRequired={bDeadLineIsRequired} aBlocks={aBlocks} watch={watch} fnSetBIsDisabledButton={fnSetBIsDisabledButton} fnSetOblockSelected={fnSetOblockSelected} nStep={nStep} bisEditAutomation={bIsEditAutomation} setError={setError} clearErrors={clearErrors} />,
        event: <RcmpTriggerEvent key={1} setValue={setValue} errors={errors} getValues={getValues} cUserTimezone={cUserTimezone} bDeadLineIsRequired={bDeadLineIsRequired} aBlocks={aBlocks} watch={watch} fnSetBIsDisabledButton={fnSetBIsDisabledButton} fnSetOblockSelected={fnSetOblockSelected} fnSetCEventSelected={fnSetCEventSelected} cEventSelected={cEventSelected} bIsEditAutomation={bIsEditAutomation} bActiveAutomation={bActiveAutomation} />
    }

    function fnSelectedTrigger(e) {
        if ((!e?.value)) {

            setValue('repeatAt', 15);
            setValue('repeatRange', {
                label: intl.get("modal_new_form.minutes"),
                value: "minute",
            },);
            setValue('beginDate', undefined);
            setValue('beginTime', undefined);
            setValue('daysOfWeekRecurrence', []);
            setValue('deadLineValue', 0);
            setValue('deadLineRange', undefined);
            setValue('notDeadLine', false);
            setValue('event', undefined);
            setValue('days', 0);
            setValue('blockId', undefined);
            setValue('observedBlockId', undefined);
            setValue('blockId', undefined);
            fnSetCEventSelected("")
        }
        if (e) {
            if (e.value === "recurrence") {
                setValue("event", "activity_trigger")
                setValue("triggerType", "activity_creation")
            }
            setValue("trigger", e)
            fnSetBTriggerSelected(e.value)
            return
        }

        setValue("trigger", undefined)
        fnSetBTriggerSelected(false)

    }


    function fnGenerateTextEvent() {
        switch (cEventSelected) {
            case "notification_expires_in":
                return intl.get("modal_new_automation.create_notification_params.activity_expires_in")
            case "notification_expires_ago":
                return intl.get("modal_new_automation.create_notification_params.activity_expires_ago")
            case "activity_created":
                return intl.get("modal_new_automation.notification_params.activity_created_manual")
            case "activity_moved":
                return intl.get("modal_new_automation.notification_params.activity_moved")
            case "activity_finished":
                return intl.get("modal_new_automation.notification_params.activity_finished")
            case "activity_deleted":
                return intl.get("modal_new_automation.notification_params.activity_deleted")
            default:
                return ""
        }
    }
    return (

        <div className={styles.modalContent}>

            {bTiggerSelected && <div className={styles.headerDescription}>
                <Typography type="l2" color="#415364">{bTiggerSelected === "recurrence" ? intl.get("modal_new_automation.create_activity_called") : intl.get("modal_new_automation.when_a")}</Typography>
                {bTiggerSelected === "event" && <p>{fnGenerateTextEvent()}...</p>}
            </div>}
            <div className={styles.triggerSelect}>
                <Select options={oAutomationTypeOptions} onSelect={(e) => fnSelectedTrigger(e)} label={intl.get("modal_new_automation.trigger")} defaultValue={getValues("trigger") || ""} placeholder={intl.get("select")} disabled={bIsEditAutomation || bActiveAutomation}/>

            </div >
            {bTiggerSelected && aTriggerSelected[bTiggerSelected]
            }
        </div >
    )
}


function RcmpSecondStep(props) {
    const { getValues, aFields, setValue, fnFormatDate, fnSetCRecurrence, cRecurrence, fnGenerateTextEvent } = props

    const containerRef = useRef(null)
    const cDeadLineValue = getValues()
    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault(); // Impede o comportamento padrão da tecla Enter
        }
    }
    useEffect(() => {
        switch (getValues("repeatRange")?.value) {
            case "day":
                fnSetCRecurrence(intl.get("modal_new_automation.recurrence_param.dailly"))
                break;
            case "week":
                fnSetCRecurrence(intl.get("modal_new_automation.recurrence_param.weekly"))
                break;
            case "month":
                fnSetCRecurrence(intl.get("modal_new_automation.recurrence_param.monthly"))
                break;
            case "hour":
                fnSetCRecurrence(intl.get("modal_new_automation.recurrence_param.hourly"))
                break;
            case "minute":
                fnSetCRecurrence(intl.get("modal_new_automation.recurrence_param.minutes"))
                break;

            case "year":
                fnSetCRecurrence(intl.get("modal_new_automation.recurrence_param.yearly"))
                break;
            default:
                fnSetCRecurrence("")
                break;
        }


    }, [])

    return (
        <>
            <div
                className={styles.container}
                ref={containerRef}
                id="fieldContainer"
            >
                {
                    getValues("trigger").value == "recurrence" ? (<div className={styles.headerDescriptionData}>
                        <Typography type="l2" color="#415364">{intl.get("modal_new_automation.create_activity_called")}</Typography>
                        <p>{getValues("automationName")},</p>
                        <Typography type="l2" color="#415364">{intl.get("modal_new_automation.repeting")}</Typography>
                        <p>{cRecurrence}</p>
                        <Typography type="l2" color="#415364">{intl.get("modal_new_automation.begining")}</Typography>
                        <p>{fnFormatDate(getValues("beginDate"), "DD/MM/YYYY")}</p>
                        <Typography type="l2" color="#415364">{intl.get("modal_new_automation.deadline")}</Typography>
                        <p>{intl.get("modal_new_automation.deadline_second_part")}</p>
                        {getValues("deadLineValue") && <p>{cDeadLineValue.deadLineValue} {getValues("deadLineRange").label}</p>}
                    </div>
                    ) :
                        (
                            <div className={styles.headerDescriptionData}>
                                <Typography type="l2" color="#415364">{intl.get("modal_new_automation.when_a")}</Typography>
                                {fnGenerateTextEvent()}
                            </div>
                        )
                }
    
                <div className={styles.headerDataAutomation}>

                </div>
                <div className={styles.intoTextContainer}>
                    <InfoIcon />
                    <p>{intl.get("modal_new_automation.info_text_values")}</p>
                </div>
                <div
                    className={styles.contentModal}
                >
                    <div onChange={e => { e.preventDefault(); e.stopPropagation() }}>
                        {aFields?.length ? aFields?.map((field, i) => {
                            if (field.opfd_cslug === cDeadLineSlug) return null
                            return (
                                <>


                                    <RcmpActivityField
                                        {...field}
                                        opfd_cname={field?.opfd_cname}
                                        ombf_bautofill={field?.ombf_bautofill}
                                        opfd_cslug={field?.opfd_cslug}
                                        opfd_ctype={field?.opfd_ctype}
                                        opfd_nid={field?.opfd_nid}
                                        bIsEdit={false}
                                        bCanUnregister={false}
                                        values={aFields}
                                        onKeyDown={handleKeyDown}
                                        key={i}
                                    />

                                </>
                            )
                        }) : (
                            <div className={styles.notFieldsForm}>
                                <Typography textAlign="center" type="p1" color="#5A646E">{intl.get("form.not_fields")}</Typography>
                            </div>
                        )}

                    </div>
                </div>

            </div>
        </>
    )
}


function RcmpThirdtStep(props) {
    const { getValues, setValue, aFieldsNewAutomation, oUser, cUserTimezone, bIsOpenError, fnSetBIsOpenError, bIsEditAutomation, cRecurrence, cEventText, fnSetCEventText, fnGenerateTextEvent } = props
    const currentDate = new Date()
    const currentDateString = currentDate.toLocaleDateString()

    useEffect(() => {
        switch (getValues("triggerType")?.value) {
            case "activity_expires_in":
                if (getValues("days") > 0) {
                    fnSetCEventText(intl.get("modal_new_automation.event_params_info.deadline_activity.activity_expires_in"))
                    return
                }
                fnSetCEventText(intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today"))
                break;
            case "activity_expires_ago":
                if(getValues("days") > 0){
                fnSetCEventText(intl.get("modal_new_automation.event_params_info.deadline_activity.activity_expires_ago"))
                return
                }
                fnSetCEventText(intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today"))
                break
            default:
                break
        }
    }, [])

    const oResponsible = aFieldsNewAutomation.find(field => field.opfd_cslug === cResponsiblesSlug)
    if (!oResponsible?.opfv_cvalue?.length) {
        setValue("responsibles", [oUser?.data?.user_nid])
    }
    function fnHandleCloseModalError() {
        fnSetBIsOpenError(false)
    }

    let aResponsibles = oResponsible?.opfv_cvalue?.length > 0 ? oResponsible?.opfv_cvalue?.map(responsible => { return responsible.user_cname }).join(", ") : oUser.data.user_cname

    const dataToShow = {
        daysNumber: getValues("repeatAt") || 1,
        repeatRange: getValues("repeatRange")?.label || intl.get("modal_new_form.minutes"),
        beginDate: fnFormatDate(getValues("beginDate"), "DD/MM/YYYY") || currentDateString,
        deadLineRange: getValues("deadLineRange")?.label || intl.get("modal_new_form.minutes"),
        deadLineValue: getValues("deadLineValue") || 1,
        beginTime: getValues("beginTime") || moment(new Date()).tz(cUserTimezone).format("HH:mm"),
        automationTitle: `${getValues("automationName") !== undefined ? `"${getValues("automationName")}"` : ""}`,
        blockName: getValues("blockId")?.label,
        responsibles: aResponsibles,
    }

    return (
        <div className={styles.checkoutContainer}>
            <p>{intl.get("modal_new_automation.review_text")}</p>
            <div className={styles.textInfoReview}>
                <div className={styles.checkoutTextContainer}>
                    {getValues("trigger").value === "recurrence" ? (
                        <p className={styles.firstLineContainer}>
                            {intl.get("modal_new_automation.text_confirmation.first_line_each")}
                            <span className={styles.dataRender}>
                                {cRecurrence}
                            </span>
                            {intl.get("modal_new_automation.text_confirmation.first_line_days")}
                            <span className={styles.dataRender}>{dataToShow.beginDate}</span>
                            {intl.get("modal_new_automation.text_confirmation.deadline")}
                            <span className={styles.dataRender}>{intl.get("modal_new_automation.text_confirmation.deadline_second_part")} {dataToShow.deadLineValue} {dataToShow.deadLineRange}</span>
                            {intl.get("modal_new_automation.text_confirmation.second_line")}
                            <span className={styles.dataRender}>{dataToShow.blockName}</span>
                        </p>
                    ) :

                        (
                            <p className={styles.firstLineContainer}>
                                <Typography type="l2" color="#415364">{intl.get("modal_new_automation.when_a")}</Typography>

                                {fnGenerateTextEvent()}
                            </p>
                        )
                    }

                    <p className={styles.secondLineContainer}>
                        {intl.get("modal_new_automation.text_confirmation.third_line")}
                        <span className={styles.dataRender}>{dataToShow.responsibles}</span>
                    </p>
                </div >

            </div >
            <RcmpModalInfo
                bIsOpen={bIsOpenError}
                size="sm"
                title={intl.get("generic_error")}
                description={bIsEditAutomation ? intl.get("modal_new_automation.error_submit_edit_atomation_time") : intl.get("modal_new_automation.error_submit_automation_time")}
                subText={intl.get("modal_new_automation.error_submit_edit_atomation_time_message")}
                fnHandleCancel={fnHandleCloseModalError}
                fnHandleConfirm={fnHandleCloseModalError}
                buttonSaveText={intl.get("close")}
                oButtonCancelProps={{ style: { display: "none" } }}
                oButtonSaveProps={{ style: { width: "100%" } }}
            />
        </div >
    )
}

function RcmpFivetStep(props) {
    const { oNewAutomationRes, cust_id, bIsEditAutomation, oUpdateAutomationRes, bShareAutomation, oAutomation } = props
    const qrCodeRef = useRef(null)
    const cFormLink = window.location.origin + process.env.PUBLIC_URL + '/automation/'
    const nAutomationId = !bIsEditAutomation && !bShareAutomation ? oNewAutomationRes?.data?.data?.id : bShareAutomation ? oAutomation.id : oUpdateAutomationRes?.data?.data?.id
    const cType = !bIsEditAutomation ? oNewAutomationRes?.data?.data?.type : oAutomation.type

    function fnOpenCopied() {
        return toast({
            type: "success",
            title: intl.get("modal_new_form.link_copied"),
        })
    }
    async function downloadQR() {
        const canvas = document.getElementById("qrCodeForm")

        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/jpg")
                .replace("image/jpg", "image/octet-stream")
            let downloadLink = document.createElement("a")
            downloadLink.href = pngUrl
            downloadLink.download = `qrCode_${`automação`}.jpg`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
        } else {
            console.error("QR Code canvas not found.")
        }
    }

    function fnCopyAutomationLink() {
        const cLink = `${cFormLink + nAutomationId}/${cust_id}`
        navigator.clipboard.writeText(cLink)
        fnOpenCopied()

    }
    return (
        <div className={styles.shareAutomationContainer}>
            <div className={styles.containerShareAutomation} style={{ paddingTop: bShareAutomation ? "30px" : "" }}>
                {!bShareAutomation && <div className={styles.textShareAutomation}>
                    <ConfirCircleIcon />
                    <Typography color={bShareAutomation ? "" : "#1D8D3C"} type={"h2"} className={styles.confirmText} >{!bIsEditAutomation ? intl.get("modal_new_automation.created_automation") : intl.get("modal_new_automation.edited_automation")}</Typography>

                </div>}
                {cType !== "notification_trigger" && <div className={styles.actionShareAutomation} >
                    <div>
                        <LinkShareIcon onClick={fnCopyAutomationLink} />
                        <Button type="button" onClick={fnCopyAutomationLink}>{intl.get("modal_new_form.copy_link")}</Button>
                    </div>
                    <div>
                        <QRCodeCanvas
                            id="qrCodeForm"
                            value={`${cFormLink + nAutomationId}/${cust_id}`}
                            renderAs={"canvas"}
                            size={1024}
                            level={"L"}
                            includeMargin={false}
                            ref={qrCodeRef}
                            style={{ display: "none" }}
                        />
                        <QrCodeIcon onClick={downloadQR} />
                        <Button type="button" onClick={downloadQR} >{intl.get("modal_new_form.copy_qrcode")}</Button>
                    </div>
                </div>}
            </div>

        </div>
    )
}

export default function RcmpModalNewAutomation(props) {
    const { bIsOpen, bIsEdit, fnOnClose, aBlocks, oCurrentBoard, fnGetAllBlocksToList, nBoardId, oCreateBlock } = props

    const { oNewAutomationRes, fnONewAutomationReq, bIsEditAutomation, oGetAutomationData, fnUpdateAutomationReq, oUpdateAutomationRes, bShareAutomation, oAutomation, bActiveAutomation } = useContext(automationContext)
    function fnFormatDataToEditForm() {
        if (!bIsEditAutomation || !oAutomation) return null
        const oBlockSelectedEdit = aBlocks.filter(block => block.opbl_nid === oAutomation.blockId)
        const formatedValueSelectedBlockEdit = { label: oBlockSelectedEdit[0]?.opbl_cname, value: oBlockSelectedEdit[0]?.opbl_nid }
        let aResponsiblesOnEditForm = oAutomation.responsibles?.map(responsible => {
            return {
                label: responsible.user_cname,
                value: responsible.user_nid
            }
        })
        let formatedFields = oAutomation.fields?.map(field => {
            return {
                visible_new_form: field.isVisible,
                opvf_bis_visible: true,
                opfd_nid: field.field_id,
                opfd_cname: field.name,
                options: field.options,
                position: field.position,
                opfd_cprecision: field.precision,
                opfd_cprefix: field.prefix,
                ombf_brequired: field.required,
                opfd_cslug: field.slug,
                opfd_csuffix: field.suffix,
                opfd_ctype: field.type,
                ombf_bautofill: field.autofill
            }
        })
        formatedFields?.sort((a, b) => a.position - b.position)
        return {
            ...oAutomation,
            blockId: formatedValueSelectedBlockEdit,
            timeRanger: { label: "", value: oAutomation.timeRanger },
            responsibles: aResponsiblesOnEditForm,
            fields: formatedFields
        }
    }
    const initialSchema = yup.object().shape({
        automationType: yup.object().shape({
            label: yup.string().required('Campo obrigatório'),
            value: yup.string().required('Campo obrigatório'),
        }).nullable().required(),
        automationName: yup.string()
            .trim()
            .required('Campo obrigatório')
            .test('isWhitespace', 'Não é permitido somente espaço em branco.', value => {
                return !/^\s*$/.test(value);
            }),
    });
    const { oUser } = useContext(AuthContext)
    const cUserTimezone = oUser?.data?.user_ctimezone || "America/Sao_Paulo"
    const formatedDataEditForm = fnFormatDataToEditForm()
    const [bValidate, fnSetBValidate] = useState(true)
    const [bDisabledButton, fnSetBIsDisabledButton] = useState(false)
    const aSteps = [intl.get("modal_new_automation.settings"), intl.get("modal_new_automation.data"), intl.get("modal_new_automation.revision")]
    const [nStep, fnSetNStep] = useState(bShareAutomation ? 4 : 0)
    const [oBlockSelected, fnSetOblockSelected] = useState({})
    const [bIsLoading, fnSetBIsLoading] = useState(false)
    const [bIsOpenModalInfo, fnSetBIsOpenModalInfo] = useState(false)
    const [bIsEmptyForm, fnSetBIsEmptyForm] = useState(true)
    const [aFieldsNewAutomation, fnSetAFieldsNewAutomation] = useState([])
    const [aSettingForm, fnSetASettingForm] = useState([])
    const [oSchemaFields, fnSetOSchemaFields] = useState(undefined)
    const [aUsers, fnSetAUsers] = useState([])
    const [bIsOpenError, fnSetBIsOpenError] = useState(false)
    const [cAutomationType, fnSetCAutomationType] = useState("")
    const [cRecurrence, fnSetCRecurrence] = useState("")
    const [dCompairDate, fnSetDComparDate] = useState(fnFormatDate(new Date(), "YYYY-MM-DD", false, cUserTimezone, "YYYY-MM-DD HH:mm"))
    const [dCompairTime, fnSetDComparTime] = useState(fnFormatDate(new Date(), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", false, cUserTimezone, "HH:mm"))
    const [aMatchingFields, fnSetAMatchingFields] = useState([])
    const [oSchemaTrigger, fnSetOSchemaTrigger] = useState(initialSchema)
    const [oGetUserRes, fnGetUsersReq] = useDataApi(fnGetUsers)
    const [cEventText, fnSetCEventText] = useState("")
    const { aAllFields } = useContext(FieldsContext)
    const oAutomationDataEdit = bIsEditAutomation && oGetAutomationData?.data?.data
    const oBoardModel = oCurrentBoard?.board_model || oCurrentBoard.data[0]?.board_model
    function fnFormatFieldsData() {
        if (oSchemaFields) return
        const newObj = bIsEditAutomation ? oAutomationDataEdit.fields : oBoardModel?.fields?.map(({ field, ...rest }) => ({ ...rest, ...field }))
        const aFieldsToSchemaFormated = newObj?.map((field, i) => {
            const value = bIsEditAutomation ? field.value : []
            if (
                field.opfd_cslug === cStatusSlug ||
                field.opfd_cslug === cDeadLineSlug ||
                field.opfd_cslug === dCreationDateSlug ||
                field.opfd_cslug === dConclusionDateSlug
                && !bIsEditAutomation
            ) {
                return null
            }
            if (field.opfd_ctype === "TEXT") {
                const { value, field_id, name, slug, type, ...rest } = field

                return {
                    ...field,
                    opfd_cname: field.ombf_brequired === "TO_CREATE" ? field.opfd_cname + "*" || field.cname + "*" : field.opfd_cname || field.name,
                    ombf_brequired: field.ombf_brequired === "TO_CREATE",
                    opvf_bis_visible: true,
                    visible_new_form: true,
                    values: "",
                    opfv_cvalue: "",
                }
            }
            return {
                ...field,
                opfd_cname: field.ombf_brequired === "TO_CREATE" ? field.opfd_cname + "*" || field.cname + "*" : field.opfd_cname || field.name,
                ombf_brequired: field.ombf_brequired === "TO_CREATE",
                opvf_bis_visible: true,
                visible_new_form: true,
                values: value,
                opfv_cvalue: value,

            }
        }).filter(item => item !== null)
        const aFieldsToSchemaFormatedEdit = newObj?.map((field, i) => {
            const oValue = bIsEditAutomation ? field.value : []
            if (
                field.slug === cStatusSlug ||
                field.slug === cDeadLineSlug ||
                field.slug === dCreationDateSlug ||
                field.slug === dConclusionDateSlug
                && bIsEditAutomation
            ) {
                return null
            }
            if (field.type === "PEOPLES") {
                let aPeoples = field?.value?.map(people => {
                    return {
                        value: people.user_nid,
                        label: people.user_cname,
                    }
                })
                let aValues = field?.value?.map(v => {
                    return {
                        user_cemail: v.user_cemail,
                        user_cname: v.user_cname,
                        user_nid: v.user_nid,
                    }
                })
                const { value, field_id, name, slug, type, ...rest } = field
                return {
                    ...rest,
                    opfd_cname: field.required === "TO_CREATE" ? name + "*" || field.cname + "*" : name || field.name,
                    ombf_brequired: field.required === "TO_CREATE",
                    opvf_bis_visible: true,
                    visible_new_form: true,
                    values: aValues,
                    opfd_cslug: field.slug,
                    opfd_ctype: field.type,
                    opfd_nid: field.field_id,
                    ombf_opfd_nid: field.field_id,
                    opfv_opfd_nid: field.field_id,
                    opfv_cvalue: aValues,
                    defaultValue: aPeoples,
                }
            }
            if (field.type === "TEXT") {
                const { value, field_id, name, slug, type, ...rest } = field

                return {
                    ...rest,
                    opfd_cname: field.required === "TO_CREATE" ? name + "*" : name,
                    ombf_brequired: field.required === "TO_CREATE",
                    opvf_bis_visible: true,
                    values: [{ opfv_opfd_nid: field.field_id, opfv_cvalue: value }],
                    opfd_cslug: field.slug,
                    opfd_ctype: field.type,
                    opfd_nid: field.field_id,
                    ombf_opfd_nid: field.field_id,
                    opfv_opfd_nid: field.field_id,
                    opfv_cvalue: ""

                }
            }
            const { value, field_id, name, slug, type, option_id, ...rest } = field
            const oSelectedOption = field?.options.find(option => option.id === field.option_id)
            const oSelectedOptionFormated = oSelectedOption ? {
                opfs_coption_color: oSelectedOption.optionColor,
                opfs_coption_name: oSelectedOption.optionName,
                opfs_nid: oSelectedOption.id,
                opfs_opfd_nid: field.field_id,
            } : undefined
            const nPrecision = field?.precision
            const options = field?.options?.map(option => {
                return {
                    opfs_coption_color: option.optionColor,
                    opfs_coption_name: option.optionName,
                    opfs_nid: option.id,
                    opfs_opfd_nid: field.field_id,
                    op_panel_active: true
                }
            })
            return {
                ...rest,
                opfd_cname: field.required === "TO_CREATE" ? field.name + "*" : field.name,
                ombf_brequired: field.required === "TO_CREATE",
                opvf_bis_visible: true,
                visible_new_form: true,
                values: oValue,
                opfd_cslug: field.slug,
                opfd_ctype: field.type,
                opfd_nid: field.field_id,
                ombf_opfd_nid: field.field_id,
                opfv_opfd_nid: field.field_id,
                opfd_nprecision: nPrecision,
                opfd_cprefix: field.prefix ?? "",
                opfd_csuffix: field.suffix ?? "",
                prefix: field.prefix ?? "",
                suffix: field.suffix ?? "",
                opfv_cvalue: oValue,
                selected_option: oSelectedOptionFormated,
                options: options,

            }
        }).filter(item => item !== null)
        const hasResponsibleSlug = aFieldsToSchemaFormated?.some(field => field.opfd_cslug === cResponsiblesSlug)
        if (!hasResponsibleSlug && !bIsEditAutomation) {
            const oResponsibleFieldId = aAllFields.find(field => field.opfd_cslug === cResponsiblesSlug)
            const newField = {
                ...oResponsibleFieldId,
                opfd_cslug: cResponsiblesSlug,
                opfd_ctype: "PEOPLES",
                opfd_cname: intl.get("CardBoard.responsibles"),
                ombf_opfd_nid: oResponsibleFieldId?.opfd_nid,
                ombf_nid: oResponsibleFieldId?.opfd_nid,
                ombf_brequired: false,
                opfv_cvalue: [],
                values: [],
                opvf_bis_visible: true,
                visible_new_form: true
            }
            aFieldsToSchemaFormated.push(newField)
        }
        return !bIsEditAutomation ? aFieldsToSchemaFormated : aFieldsToSchemaFormatedEdit
    }



    function fnCreateSchema() {
        if (oSchemaFields) return
        const aFieldsToSchemaFormated = fnFormatFieldsData()
        if (!aFieldsToSchemaFormated) return
        const oSchema = fnCreateFieldsValitionSchema(
            aFieldsToSchemaFormated,
            bIsEdit,
        )
        if (oSchema === undefined) return false
        return oSchema
    }

    const buttonRef = useRef(null)
    const modalContainerRef = useRef(null)
    let aFormatedData = fnFormatFieldsData()

    useEffect(() => {
        if (!bIsOpen) return
        fnGetAllBlocksToList();
    }, [bIsOpen]);

    useEffect(() => {
        if (!aFormatedData || aFieldsNewAutomation?.length > 0 || oSchemaFields) return
        fnSetAFieldsNewAutomation(aFormatedData)
    }, [nStep])

    useEffect(() => {
        if (aSettingForm?.length === 0 && bIsOpen && !bIsEditAutomation) {
            let fieldParams = aFieldsNewAutomation?.map((field, i) => (
                {
                    fieldId: field.ombf_opfd_nid || field.opfd_nid,
                    isVisible: true,
                    required: false,
                    name: field?.opfd_cname,
                    slug: field?.opfd_cslug,
                    type: field?.opfd_ctype,
                    position: i
                }
            ))
            fnSetASettingForm(fieldParams)
        }
        if (bIsEdit) {
            oAutomation.fields?.sort((a, b) => a.position - b.position)
            fnSetASettingForm(oAutomation.fields)
        }

        if (nStep !== 2 && oSchemaFields !== undefined) {
            const aValues = getValues()
            if (aValues) {
                let aFieldsWithValues = aFieldsNewAutomation?.map(field => {
                    if (!aValues[cPrefixFieldName + field?.ombf_opfd_nid]) {
                        if (field.opfd_ctype === "NUMBER") {
                            return {
                                ...field,
                                opfv_cvalue: "",
                                values: [],
                                value: "",
                                opfv_opfd_nid: field.ombf_opfd_nid

                            }
                        }
                        if (field.opfd_ctype === "SELECTION") {
                            return {
                                ...field,
                                selected_option: undefined,
                                opfv_cvalue: undefined,
                                opfv_opfd_nid: field?.ombf_opfd_nid
                            }
                        }
                        return {
                            ...field,
                            opfv_opfd_nid: field?.ombf_opfd_nid
                        }
                    }
                    if (field?.opfd_ctype === "SELECTION") {
                        const oSelectedOption = field.options.find(option => option.opfs_nid === aValues[cPrefixFieldName + field.ombf_opfd_nid])
                        if (!oSelectedOption) return {
                            ...field,
                        }
                        return {
                            ...field,
                            selected_option: oSelectedOption || undefined,
                            opfv_opfd_nid: field.ombf_opfd_nid
                        }
                    }
                    if (field?.opfd_ctype === "DATE") {
                        if (!aValues[cPrefixFieldName + field.ombf_opfd_nid].length || !aValues[cPrefixFieldName + field.ombf_opfd_nid]) {
                            return {
                                ...field,
                                opfv_cvalue: null,
                                values: [{ opfv_opfd_nid: field.ombf_opfd_nid, opfv_cvalue: null }],
                                opfv_opfd_nid: field.ombf_opfd_nid
                            }
                        }
                        const dFormatedDate = moment(aValues[cPrefixFieldName + field.ombf_opfd_nid]).add(3, 'hours').format('YYYY-MM-DD HH:mm:ss')
                        const dToUtcDateFormated = fnFormatDateToUTC(dFormatedDate, "America/Sao_Paulo", "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
                        return {
                            ...field,
                            opfv_cvalue: dToUtcDateFormated,
                            values: [{ opfv_opfd_nid: field.ombf_opfd_nid, opfv_cvalue: dToUtcDateFormated }],
                            opfv_opfd_nid: field.ombf_opfd_nid
                        }
                    }
                    if (field?.opfd_ctype === "PEOPLES" && field.opfd_cslug === cResponsiblesSlug) {
                        if (!aValues[cPrefixFieldName + field.ombf_opfd_nid].length || !aValues[cPrefixFieldName + field.ombf_opfd_nid]) {
                            return {
                                ...field,
                                opfv_cvalue: [{
                                    user_nid: oUser.data.user_nid,
                                    user_cname: oUser.data.user_cname,
                                    user_cemail: oUser.data.user_cemail
                                }],
                                values: [
                                    {
                                        user_nid: oUser.data.user_nid,
                                        user_cname: oUser.data.user_cname,
                                        user_cemail: oUser.data.user_cemail
                                    }
                                ],
                                opfv_opfd_nid: field.ombf_opfd_nid
                            }
                        }
                        let oUSersValues = aUsers.filter(user => aValues[cPrefixFieldName + field.ombf_opfd_nid].includes(user.user_nid))
                        return {
                            ...field,
                            opfv_cvalue: oUSersValues,
                            values: [{
                                opfv_opfd_nid: field.ombf_opfd_nid, opfv_cvalue: oUSersValues?.map(user => ({
                                    user_nid: user.user_nid,
                                    user_cname: user.user_cname,
                                    user_cemail: user.user_cemail
                                }))
                            }],
                            opfv_opfd_nid: field.ombf_opfd_nid
                        }
                    }
                    if (field?.opfd_ctype === "PEOPLES") {
                        if (!aValues[cPrefixFieldName + field.ombf_opfd_nid].length || !aValues[cPrefixFieldName + field.ombf_opfd_nid]) {
                            return {
                                ...field,
                                opfv_cvalue: [],
                                values: [],
                                opfv_opfd_nid: field.ombf_opfd_nid
                            }
                        }
                        let oUSersValues = aUsers.filter(user => aValues[cPrefixFieldName + field.ombf_opfd_nid].includes(user.user_nid))

                        return {
                            ...field,
                            opfv_cvalue: oUSersValues,
                            values: [{
                                opfv_opfd_nid: field.ombf_opfd_nid, opfv_cvalue: oUSersValues?.map(user => ({
                                    user_nid: user.user_nid,
                                    user_cname: user.user_cname,
                                    user_cemail: user.user_cemail
                                }))
                            }],
                            opfv_opfd_nid: field.ombf_opfd_nid
                        }
                    }
                    if (field?.opfd_ctype === "NUMBER") {
                        if (!aValues[cPrefixFieldName + field.ombf_opfd_nid].length || !aValues[cPrefixFieldName + field.ombf_opfd_nid]) {

                            return {
                                ...field,
                                opfv_cvalue: "",
                                values: [],
                                value: "",
                                opfv_opfd_nid: field.ombf_opfd_nid
                            }
                        }

                        return {
                            ...field,
                            opfv_cvalue: "",
                            value: aValues[cPrefixFieldName + field.ombf_opfd_nid],
                            values: [{ opfv_opfd_nid: field.ombf_opfd_nid, opfv_cvalue: aValues[cPrefixFieldName + field.ombf_opfd_nid] }],
                            opfv_opfd_nid: field.ombf_opfd_nid
                        }
                    }

                    return {
                        ...field,
                        values: [{ opfv_opfd_nid: field.ombf_opfd_nid, opfv_cvalue: aValues[cPrefixFieldName + field.ombf_opfd_nid] }],
                        opfv_opfd_nid: field.ombf_opfd_nid,
                    }
                })
                if (!aFieldsWithValues) return
                fnSetAFieldsNewAutomation(aFieldsWithValues)
            }
        }


    }, [nStep])


    const bDeadLineIsRequired = oCurrentBoard?.board_model?.fields?.some(field => field?.field?.opfd_cslug === cDeadLineSlug && field.ombf_brequired === "TO_CREATE")
    const schema = nStep === 0 || nStep === 1 || (nStep === 2 && cAutomationType === "notification_trigger") ?
        oSchemaTrigger : oSchemaFields

    const useFormMethods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: yupResolver(schema),
    })
    let aDinamycFieldsName = !bIsEditAutomation ? oBoardModel?.fields?.map(field => { return cPrefixFieldName + field.ombf_opfd_nid }) : oAutomationDataEdit.fields?.map(field => { return cPrefixFieldName + field.field_id }) ?? []






    const aFields = ["blockId", "automationName", ...aDinamycFieldsName]
    const {
        register,
        setValue,
        handleSubmit,
        getValues,
        reset,
        watch,
        trigger,
        clearErrors,
        setError,
        formState: { errors, isDirty },
    } = useFormMethods
    const cCurrentDay = moment().tz(cUserTimezone).format("DD")
    useEffect(() => {
        let newSchema = {};

        if (nStep === 0 || nStep === 3) {
            fnSetOSchemaTrigger(initialSchema);
            return;
        }

        switch (getValues("automationType")?.value) {
            case "notification_trigger":
                if (nStep === 1) {
                    newSchema = yup.object().shape({
                        triggerType: yup.object().shape({
                            label: yup.string().required(intl.get("fields.required_field")),
                            value: yup.string().required(intl.get("fields.required_field")),
                        }),
                        fromBlockId: yup.mixed(),
                        observedBlockId: yup.mixed(),
                        blockEvent: yup.mixed(),
                        blockMoved: yup.mixed(),
                    })
                    fnSetOSchemaTrigger(prev => {
                        return yup.object().shape({
                            ...newSchema.fields,
                        });
                    });
                }
                if (nStep === 2) {
                    newSchema = yup.object().shape({
                        notificationMessage: yup.string()
                            .trim()
                            .required(intl.get("fields.required_field"))
                            .test('isWhitespace', intl.get("cant_fill_with_space"), value => {
                                return !/^\s*$/.test(value);
                            }),
                        userTypeNotification: yup.object().shape({
                            label: yup.string().required(intl.get("fields.required_field")),
                            value: yup.string().required(intl.get("fields.required_field")),
                        }),
                        userNotificade: yup.array().of(yup.object().shape({
                            label: yup.string(),
                            value: yup.string(),
                        })).nullable(true),
                        userExterPhone: yup.string(),
                        userExternName: getValues("userTypeNotification")?.value === "external" ? yup.string()
                            .trim()
                            .test('isWhitespace', intl.get("cant_fill_with_space"), value => {
                                return !/^\s*$/.test(value);
                            }) : yup.string().nullable(true),
                        userExternEmail: yup.string().email(intl.get("modal_new_automation.create_notification_params.invalid_email")),
                    });
                    fnSetOSchemaTrigger((prev) => {
                        return yup.object().shape({
                            ...newSchema.fields,
                        });
                    });
                }
                break
            case "activity_trigger":
                if (nStep === 1 && !getValues("trigger")) {
                    fnSetBIsDisabledButton(true)
                    return
                }
                if (nStep > 1 || nStep === 0 || !getValues("trigger")) {
                    fnSetOSchemaTrigger(initialSchema)

                    return
                };
                if (nStep === 1 && getValues("trigger")?.value === "recurrence") {
                    newSchema = yup.object().shape({
                        blockId: yup.mixed().required('Campo obrigatório'),
                        repeatAt: yup.number().required('Campo obrigatório'),
                        repeatRange: yup.mixed(),
                        beginDate: yup.date().required('Campo obrigatório'),
                        beginTime: yup.string().required('Campo obrigatório'),
                        daysOfWeekRecurrence: yup.array().of(yup.number()),
                        deadLineValue: yup.number().nullable(true),
                        deadLineRange: yup.mixed(),
                        notDeadLine: yup.boolean().default(false),
                        trigger: yup.object().shape({
                            label: yup.string().required('Campo obrigatório'),
                            value: yup.string().required('Campo obrigatório'),
                        }),
                        automationType: yup.object().shape({
                            label: yup.string().required('Campo obrigatório'),
                            value: yup.string().required('Campo obrigatório'),
                        }),
                    });
                } else if (nStep === 1 && getValues("trigger")?.value === "event") {
                    newSchema = yup.object().shape({
                        triggerType: yup.object().shape({
                            label: yup.string().required('Campo obrigatório'),
                            value: yup.string().required('Campo obrigatório'),
                        }).required(),
                        days: yup.number().default(0),
                        blockId: yup.object().shape({
                            label: yup.string().required('Campo obrigatório'),
                            value: yup.number().required('Campo obrigatório'),
                        }).nullable(true).required(),
                        observedBlockId: yup.mixed(),
                        fromBlockId: yup.mixed(),
                        deadLineValue: yup.number().nullable(true),
                        deadLineRange: yup.mixed(),
                        notDeadLine: yup.boolean().default(false),
                        trigger: yup.object().shape({
                            label: yup.string().required('Campo obrigatório'),
                            value: yup.string().required('Campo obrigatório'),
                        }).required(),
                        automationType: yup.object().shape({
                            label: yup.string().required('Campo obrigatório'),
                            value: yup.string().required('Campo obrigatório'),
                        }).required(),
                    });
                    fnSetOSchemaTrigger(prev => {
                        return yup.object().shape({
                            ...initialSchema.fields,  // Garantir que os campos iniciais estejam presentes
                            ...prev.fields,  // Garantir que os campos anteriores estejam presentes
                            ...newSchema.fields,  // Adicionar novos campos
                        });
                    });
                }
                break
            default:

                break;
            // Adicione outros cases aqui, se houver
        }

        if (nStep === 1 && getValues("trigger")?.value === "recurrence") {
            newSchema = yup.object().shape({
                blockId: yup.mixed().required('Campo obrigatório'),
                repeatAt: yup.number().default(15).required('Campo obrigatório'),
                repeatRange: yup.mixed(),
                beginDate: yup.date().required('Campo obrigatório'),
                beginTime: yup.string().required('Campo obrigatório'),
                daysOfWeekRecurrence: yup.array().of(yup.number()),
                deadLineValue: yup.number().nullable(true),
                deadLineRange: yup.mixed(),
                notDeadLine: yup.boolean().default(false),
                trigger: yup.object().shape({
                    label: yup.string().required('Campo obrigatório'),
                    value: yup.string().required('Campo obrigatório'),
                }),
                automationType: yup.object().shape({
                    label: yup.string().required('Campo obrigatório'),
                    value: yup.string().required('Campo obrigatório'),
                }),
            });
        } else if (nStep === 1 && getValues("trigger")?.value === "event" && getValues("automationType")?.value !== "notification_trigger") {
            newSchema = yup.object().shape({
                triggerType: yup.object().shape({
                    label: yup.string().required('Campo obrigatório'),
                    value: yup.string().required('Campo obrigatório'),
                }).required(),
                days: yup.number().default(0),
                blockId: yup.object().shape({
                    label: yup.string().required('Campo obrigatório'),
                    value: yup.number().required('Campo obrigatório'),
                }).required(),
                observedBlockId: yup.mixed(),

                // blockEvent: yup.object().shape({
                //     label: yup.string().required('Campo obrigatório'),
                //     value: yup.number().required('Campo obrigatório'),
                // }).required(),
                // createActivityBlock: yup.object().shape({
                //     label: yup.string().required('Campo obrigatório'),
                //     value: yup.number().required('Campo obrigatório'),
                // }).required(),
                deadLineValue: yup.number().nullable(true),
                deadLineRange: yup.mixed(),
                notDeadLine: yup.boolean().default(false),
                trigger: yup.object().shape({
                    label: yup.string().required('Campo obrigatório'),
                    value: yup.string().required('Campo obrigatório'),
                }).required(),
                automationType: yup.object().shape({
                    label: yup.string().required('Campo obrigatório'),
                    value: yup.string().required('Campo obrigatório'),
                }).required(),
            });
            fnSetOSchemaTrigger((prev) => {
                return yup.object().shape({
                    ...initialSchema.fields,  // Garantir que os campos iniciais estejam presentes
                    ...prev.fields,  // Garantir que os campos anteriores estejam presentes
                    ...newSchema.fields,  // Adicionar novos campos
                });
            });
        }

    }, [nStep, watch("trigger"), watch("automationType"), watch("userTypeNotification")]);
    useEffect(() => {
        reset({})
        setValue("repeatRange", { label: intl.get("modal_new_form.minutes"), value: "minute" })
        setValue("repeatAt", 15)
        setValue("deadLineRange", { label: intl.get("modal_new_form.hour"), value: "hour" })
        setValue("deadLineValue", 1)
        setValue("monthDay", { label: `${cCurrentDay}`, value: cCurrentDay })
        setValue("days", 0)
        if (oGetUserRes.loading) return

        (async () => {
            const response = await fnGetUsersReq()
            fnSetAUsers(response.data)
        })()
        if (bIsEditAutomation) {
            const oAutomationType = ["activity_expires_in", "activity_expires_ago", "activity_creation", "activity_trigger"].includes(oAutomationDataEdit.type) ? {
                label: intl.get("modal_new_automation.activity_creation"),
                value: "activity_trigger"
            }
            :
            {
                label: intl.get("modal_new_automation.notification_trigger"),
                value: "notification_trigger"
            }
            const aRange = [{ label: intl.get("modal_new_form.minutes"), value: "minute" }, { label: intl.get("modal_new_form.hour"), value: "hour" }, { label: intl.get("modal_new_form.day"), value: "day" }, { label: intl.get("modal_new_form.week"), value: "week" }, { label: intl.get("modal_new_form.month"), value: "month" }]

            const cRepeatRange = aRange.find(range => range.value === oAutomationDataEdit.timeRepeatRange)
            const cDeadLineRange = aRange.find(range => range.value === oAutomationDataEdit.deadlineRange)

            setValue("blockId", { label: oAutomationDataEdit.block.name, value: oAutomationDataEdit.block.id })
            setValue("blockEvent", { label: oAutomationDataEdit.block.name, value: oAutomationDataEdit.block.id })
            setValue("automationName", oAutomationDataEdit.title)
            setValue("deadLineValue", oAutomationDataEdit.deadlineValue)
            setValue("deadLineRange", cDeadLineRange)
            setValue("notDeadLine", oAutomation.notHaveDeadline)
            setValue("repeatAt", oAutomationDataEdit.trigger !== "event" ?  oAutomationDataEdit.timeRepeatValue : null)
            setValue("repeatRange", oAutomationDataEdit.trigger !== "event" ? cRepeatRange : null)
            setValue("daysOfWeekRecurrence", oAutomationDataEdit.daysOfTheWeek)
            setValue("automationType", oAutomationType)
            setValue("trigger", { label: intl.get(`modal_new_automation.triggers.${oAutomationDataEdit.trigger}`), value: oAutomationDataEdit.trigger })
            setValue("triggerType", { label: intl.get(`modal_new_automation.event_param.${oAutomationDataEdit.triggerType}`), value: oAutomationDataEdit.triggerType })
            if (!bActiveAutomation) {
                const hourMinuteString = oAutomationDataEdit.startRepeatHour ?? "00:00"
                const [hour, minute] = hourMinuteString.split(':')


                const currentDate = moment(oAutomationDataEdit.startRepeatDate).set({
                    hour: hour,
                    minute: minute,
                    second: 0,
                }).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")

                const dDateBeginUtc = fnFormatDateFromUTC(currentDate, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", cUserTimezone)
                const dDateBeginFormated = fnFormatDate(dDateBeginUtc, "YYYY-MM-DD", false, cUserTimezone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
                setValue("type", oAutomationDataEdit.type)

                fnSetDComparDate(dDateBeginFormated)
                fnSetDComparTime(fnFormatDateFromUTC(currentDate, "HH:mm", cUserTimezone))
            }

            if (oAutomationDataEdit.trigger === "event" && oAutomationDataEdit.type === "activity_trigger") {
                setValue("days", oAutomationDataEdit.countDays)
                setValue("blockId", { label: oAutomationDataEdit.block.name, value: oAutomationDataEdit.block.id })
                setValue("observedBlockId", oAutomationDataEdit.observedBlockId === null || oAutomationDataEdit.observedBlock === null ? { label: intl.get("modal_new_automation.whatever_block"), value: null } : {  label: oAutomationDataEdit.observedBlockId.name, value: oAutomationDataEdit.observedBlockId.id })
                if(oAutomationDataEdit.triggerType === "activity_moved"){
                    setValue("fromBlockId", oAutomationDataEdit?.fromBlockId === null ? { label: intl.get("modal_new_automation.whatever_block"), value: null } : { label: oAutomationDataEdit.fromBlockId?.name, value: oAutomationDataEdit?.fromBlockId.id })
                }
            }
            if (oAutomationDataEdit.type === "notification_trigger") {
                const aInternalUserNotificade = oAutomationDataEdit.notificationRecipientType === "internal" ? oAutomationDataEdit?.recipients?.map(user => {
                    return {
                        user_cemail: user?.user?.userEmail,
                        label: user?.user?.userName,
                        Value: user?.user?.userId
                    }
                }) : null
                setValue("event", { label: intl.get(`modal_new_automation.notification_params.${oAutomationDataEdit.type}`), value: oAutomationDataEdit.type })
                setValue("blockId", oAutomationDataEdit.block === null ? { label: intl.get("modal_new_automation.whatever_block"), value: null } : { label: oAutomationDataEdit.block.name, value: oAutomationDataEdit.block.id })
                setValue("blockEvent", oAutomationDataEdit.block === null ? { label: intl.get("modal_new_automation.whatever_block"), value: null } : { label: oAutomationDataEdit.block.name, value: oAutomationDataEdit.block.id })
                setValue("notificationMessage", oAutomationDataEdit.notificationMessage)
                setValue("days", oAutomationDataEdit.countDays)
                setValue("userTypeNotification", {
                    label: intl.get(`modal_new_automation.notification_params.${oAutomationDataEdit.notificationRecipientType}`),
                    value: oAutomationDataEdit.notificationRecipientType
                },)
                setValue("userNotificade", aInternalUserNotificade)
                setValue("userExternName", oAutomationDataEdit?.recipients?.[0]?.recipinentName ?? "")
                setValue("userExternEmail", oAutomationDataEdit?.recipients?.[0]?.recipinentEmail ?? "")
                setValue("fromBlockId", oAutomationDataEdit?.fromBlockId === null || oAutomationDataEdit?.fromBlock === null ? { label: intl.get("modal_new_automation.whatever_block"), value: null } : { label: oAutomationDataEdit?.fromBlockId?.name, value: oAutomationDataEdit?.fromBlockId?.id })

            }
            oAutomationDataEdit.fields?.map(field => {

                if (field.type === "PEOPLES") {
                    setValue(cPrefixFieldName + field.field_id, field?.value?.map(user => user.user_nid))
                    return
                }
                if (field.type === "SELECTION") {
                    field?.option_id === null ? setValue(cPrefixFieldName + field.field_id, "") : setValue(cPrefixFieldName + field.field_id, field?.option_id)
                    return
                }
                field?.value === null ? setValue(cPrefixFieldName + field.field_id, "") : setValue(cPrefixFieldName + field.field_id, field?.value)

                return
            })
        }
    }, [bIsOpen])
    useEffect(() => {
        if (oSchemaFields !== undefined || nStep === 0 || getValues("automationType")?.value === "notification_trigger") return
        const response = fnCreateSchema()
        if (!response) return
        fnSetOSchemaFields(response)
    }, [nStep, watch])


    function fnOpenToastFail(response) {
        if (response.response.status === 422) {
            fnSetBIsOpenError(true)
            return
        }
        return toast({
            type: "error",
            title: intl.get("table_fields.toast.fail"),
            description: bIsEditAutomation ? intl.get("modal_new_automation.error_submit_edit_atomation") : intl.get("modal_new_automation.error_submit_automation"),
        })
    }

    function fnConfirmModalInfo() {
        fnSetBIsOpenModalInfo(false)
        fnSetNStep(1)
        fnSetAFieldsNewAutomation([])
        fnSetASettingForm([])
        fnOnClose()
    }

    function fnCancelModalInfo() {
        fnSetBIsOpenModalInfo(false)
    }

    useEffect(() => {
        if (!bIsOpen) return
        const bIsEmpty = aFields.every(campo => {
            return !getValues(campo)
        })
        fnSetBIsEmptyForm(bIsEmpty)

        // if (nStep === 1) {
        //     (async () => {
        //         try {
        //             await schema.validate(getValues(), { context: 1 })
        //             fnSetBValidate(false)
        //         } catch (validationError) {
        //             fnSetBValidate(true)
        //         }
        //     })()
        //     return
        // }
        if (nStep === 2) {

            (async () => {
                try {
                    await schema.validate(getValues(), { context: 2 })
                    fnSetBValidate(false)
                } catch (validationError) {
                    fnSetBValidate(true)
                }
            })()
            return
        }
        // if (nStep === 3) {
        //     (async () => {
        //         try {
        //             await schema.validate(getValues(), { context: 3 })
        //             fnSetBValidate(false)
        //         } catch (validationError) {
        //             fnSetBValidate(true)
        //         }
        //     })()
        //     return
        // }
        fnSetBValidate(true)
        return
    }, [getValues()])
    const validateStep = async (step) => {
        trigger("automationName", "blockId", "automationType")
        try {
            if (nStep === 0 && getValues("trigger") && getValues("automationName") && getValues("automationType")) {
                return true
            }
            if (nStep === 1 && !getValues("trigger") && getValues("automationType").value !== "notification_trigger") {
                setError("trigger", { type: "manual", message: intl.get("modal_new_automation.required_field_message") })
                trigger(oSchemaFields._nodes)
                return false
            }


            // if (nStep === 1 && getValues("automationType").value === "notification_trigger") {
            //     if (getValues("event")?.value !== "activity_moved" && !getValues("observedBlockId")) {
            //         setError("observedBlockId", { type: "manual", message: intl.get("modal_new_automation.required_field_message") })
            //         return false
            //     }
            // }
            await schema.validate(getValues(), { context: { step } })
            if (nStep === 1 && !bIsEditAutomation) {
                if (getValues("repeatRange")?.value === "minute" && getValues("repeatAt") < 15) {
                    setError("repeatAt", { type: "manual", message: intl.get("modal_new_automation.repeat_at_lower_minute") })
                    return false
                }
                if (getValues("repeatRange")?.value === "month" && getValues("repeatAt") > 12) {
                    setError("repeatAt", { type: "manual", message: intl.get("modal_new_automation.repeat_at_lower_month") })
                    return false
                }
                const momentTime1 = moment(dCompairTime, 'HH:mm')
                const momentTime2 = moment(getValues("beginTime"), 'HH:mm')
                if (momentTime1.isAfter(momentTime2) && getValues("beginDate") === moment().tz(cUserTimezone).format("YYYY-MM-DD")) {
                    setError("beginTime", { type: "manual", message: intl.get("modal_new_automation.begin_time_lower") })

                    return false

                } else if ((momentTime2.isAfter(momentTime1) || momentTime1.isAfter(momentTime2)) && getValues("beginDate") < moment().tz(cUserTimezone).format("YYYY-MM-DD")) {

                    setError("beginTime", { type: "manual", message: intl.get("modal_new_automation.begin_time_lower") })

                    return false
                }
                else if (momentTime1.isBefore(momentTime2)) {

                    return true
                } else {
                    return true
                }
            }

            if (nStep === 1 && bIsEditAutomation && (dCompairTime !== getValues("beginTime") || dCompairDate !== getValues("beginDate"))) {
                const currentDate = moment(new Date(Date.now() + 600000)).format("HH:mm")
                fnSetDComparDate(moment().tz(cUserTimezone).format("YYYY-MM-DD"))
                const momentTime1 = moment(currentDate, 'HH:mm')
                const momentTime2 = moment(getValues("beginTime"), 'HH:mm')
                if (momentTime1.isAfter(momentTime2) && getValues("beginDate") === moment().tz(cUserTimezone).format("YYYY-MM-DD")) {
                    setError("beginTime", { type: "manual", message: intl.get("modal_new_automation.begin_time_lower") })
                    return false
                } else if ((momentTime2.isAfter(momentTime1) || momentTime1.isAfter(momentTime2)) && getValues("beginDate") < moment().tz(cUserTimezone).format("YYYY-MM-DD")) {
                    setError("beginDate", { type: "manual", message: intl.get("modal_new_automation.repeat_at_lower_minute") })
                    return false
                } else if (momentTime1.isBefore(momentTime2)) {
                    return true
                } else {
                    return true
                }
            }

            if (nStep === 2 && getValues("automationType").value === "notification_trigger" && getValues("userTypeNotification").value === "external") {
                if (!getValues("userExternName")) {
                    setError("userExternName", { type: "manual", message: intl.get("fields.required_field") })
                    return false
                }
                if (!getValues("userExternEmail")) {
                    setError("userExternEmail", { type: "manual", message: intl.get("fields.required_field") })
                    return false
                }
                // if (!getValues("userExternPhone")) {
                //     setError("userExternPhone", { type: "manual", message: intl.get("fields.required_field") })
                //     return false
                // }
                return true

            }



            return true
        } catch (validationError) {

            return false
        }
    }
    async function fnFormatAutomationPaylod() {

        const oValues = getValues()
        const cNameWithoutSpace = oValues.automationName
        const aInterUsers = oValues.userNotificade?.map(user => {
            return user.value || user.Value
        })
        // let aDaysOfWeek = oValues?.repeatRange?.value === "week" ? oValues?.daysOfWeekRecurrence
        //     ?.filter(day => day.checked)
        //     ?.map(day => day.value)
        //     .filter(value => value !== undefined) : []
        let aFieldsFormated = oValues.automationType.value !== "notification_trigger" ? aFieldsNewAutomation?.map((field, i) => {

            if (field.opfd_ctype === "SELECTION") {
                const selection = getValues(cPrefixFieldName + field.ombf_opfd_nid)
                const opfv_opfs_nid = Number.isInteger(selection) ? selection : ""

                return {
                    opfd_nid: field.opfd_nid,
                    nposition: i,
                    opfv_opfs_nid: opfv_opfs_nid,
                }
            }
            if (field.opfd_ctype === "PEOPLES" && field.opfd_cslug === cResponsiblesSlug) {
                const aResponsibles = getValues(cPrefixFieldName + field.ombf_opfd_nid)
                return {
                    opfd_nid: field.opfd_nid || field.ombf_opfd_nid,
                    nposition: i,
                    peoples: aResponsibles?.length ? aResponsibles : [oUser?.data?.user_nid],
                }
            }
            if (field.opfd_ctype === "PEOPLES") {
                return {
                    opfd_nid: field.opfd_nid || field.ombf_opfd_nid,
                    nposition: i,
                    peoples: getValues(cPrefixFieldName + field.ombf_opfd_nid),
                }
            }
            return {
                opfd_nid: field.opfd_nid,
                nposition: i,
                opfv_cvalue: getValues(cPrefixFieldName + field.ombf_opfd_nid),
            }
        }) : null
        const currentTime = moment.tz(oValues.beginTime, "HH:mm", cUserTimezone)
        const [hour, minute] = currentTime.format('HH:mm').split(':')
        const currentDate = moment(oValues.beginDate).set({
            hour: hour,
            minute: minute,
            second: 0,
        }).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
        fnSetBIsLoading(true)
        fnSetBIsDisabledButton(true)
        const dDateBeginUtc = fnFormatDateToUTC(currentDate, cUserTimezone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
        const cAutomationType = ["activity_expires_in", "activity_expires_ago", "activity_creation", "activity_trigger"].includes(oValues.automationType.value) ? "activity_creation":"notification_trigger"
        
        let payloadNewAutomation = {
            blockId: oValues?.blockId?.value || null,
            observedBlockId: cAutomationType !== "notification_trigger" ?  oValues?.observedBlockId?.value : oValues.blockEvent.value,
            title: cNameWithoutSpace,
            type: oValues.triggerType.value?.includes("expires") ? oValues.triggerType.value : oValues?.trigger?.value === "recurrence" ?  oValues.triggerType : oValues?.automationType?.value,
            fields: aFieldsFormated,
            timeRepeatValue: cAutomationType === "activity_creation" && oValues.trigger.value !=="event" && oValues.trigger.value !=="event" ? oValues.repeatAt : null,
            timeRepeatRange: cAutomationType === "activity_creation" && oValues.trigger.value !=="event" ? oValues?.repeatRange?.value : null,
            startRepeatDate: oValues?.trigger?.value !== "event" ?  oValues?.beginDate ? moment(dDateBeginUtc, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]").format("YYYY-MM-DD") : null : null,
            startRepeatHour:  oValues.beginTime && oValues?.trigger?.value !== "event" ? moment.utc(currentTime, "HH:mm").format("HH:mm") : null,
            deadlineValue: cAutomationType === "activity_creation" ? oValues.deadLineValue : null,
            deadlineRange: cAutomationType === "activity_creation" ? oValues.deadLineRange?.value : null,
            notHaveDeadline: cAutomationType === "activity_creation" ? oValues.notDeadLine : 0,
            daysOfTheWeek: oValues.daysOfWeekRecurrence || null,
            trigger: oValues?.trigger?.value || "event",
            triggerType: oValues?.triggerType?.value ?? oValues?.triggerType,
            countDays: oValues.days || 0,
            fromBlockId: oValues?.fromBlockId?.value || null,
            notificationRecipientType: oValues?.userTypeNotification?.value || null,
            notificationRecipient: aInterUsers || null,
            notificationMessage: oValues.notificationMessage || null,
            notificationRecipientName: oValues.userExternName || null,
            notificationRecipientEmail: oValues.userExternEmail || null,
        }
        if (bActiveAutomation) {
            payloadNewAutomation = {
                ...payloadNewAutomation,
                status: 1
            }
        }
        if (bIsEditAutomation || bActiveAutomation) {
            const response = await fnUpdateAutomationReq(oAutomationDataEdit.id, payloadNewAutomation)
            if (response.success) {
                fnSetBIsLoading(false)
                fnSetBIsDisabledButton(false)
                fnSetNStep(nStep + 1)
                return true
            }
            fnSetBIsDisabledButton(false)
            fnOpenToastFail(response)
            fnSetBIsLoading(false)
            return false
        }
        const response = await fnONewAutomationReq(payloadNewAutomation)
        if (response.success) {
            fnSetBIsLoading(false)
            fnSetBIsDisabledButton(false)
            fnSetNStep(nStep + 1)
            return true
        }
        fnOpenToastFail(response)
        fnSetBIsDisabledButton(false)
        fnSetBIsLoading(false)
        return false

    }
    function fnScrollToTop() {
        if (modalContainerRef.current) {
            modalContainerRef.current.scrollIntoView()
            modalContainerRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            })
        }
    }

    useEffect(() => {

        const currentDate = moment(new Date(Date.now() + 600000)).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")

        if (!bIsEditAutomation) {
            fnSetDComparTime(fnFormatDate(currentDate, "HH:mm", false, cUserTimezone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"))
        }

        fnScrollToTop()
        if (nStep <= 1) return
        // switch (getValues("triggerType")?.value) {
        //     case "notification_expires_in":
        //         if (getValues("days") === 0) {
        //             return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today"))
        //         }
        //         return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_activity") + " " + getValues("days") + " " + intl.get("modal_new_automation.days"))

        //     case "notification_expires_ago":
        //         if (getValues("days") === 0) {
        //             return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.activity_expires_ago") + " 1 " + intl.get("modal_new_automation.day"))
        //         }
        //         return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expirated_since") + " " + getValues("days") + " " + intl.get("modal_new_automation.days"))
        //     case "activity_created":
        //         return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_created_manual"))
        //     case "activity_moved":
        //         return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_moved") +
        //             (getValues("fromBlockId") !== null ? getValues("fromBlockId")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.from_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.from_block") + getValues("fromBlockId")?.label : "")
        //             +
        //             (getValues("blockEvent") !== null ? getValues("blockEvent")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.to_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.to_block") + getValues("blockEvent")?.label : ""))

        //     case "activity_finished":
        //         return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_finished"))
        //     case "activity_deleted":
        //         return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_deleted"))
        //     default:
        //         return fnSetCEventText("")
        // }
        switch (getValues("triggerType")?.value) {
            case "notification_expires_in":
                if (getValues("days") === 0) {
                    return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_today"))
                }
                return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expiration_activity") + " " + getValues("days") + " " + intl.get("modal_new_automation.days"))

            case "notification_expires_ago":
                if (getValues("days") === 0) {
                    return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.activity_expires_ago") + " 1 " + intl.get("modal_new_automation.day"))
                }
                return fnSetCEventText(intl.get("modal_new_automation.activity") + intl.get("modal_new_automation.event_params_info.deadline_activity.expirated_since") + " " + getValues("days") + " " + intl.get("modal_new_automation.days"))
            case "activity_created":
                return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_created_manual"))
            case "activity_moved":

                return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_moved")
                    +
                    (getValues("fromBlockId") !== undefined ? getValues("fromBlockId")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.from_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.from_block") + getValues("fromBlockId")?.label : "")
                    +
                    (getValues("observedBlockId") !== undefined ? getValues("observedBlockId")?.value === null ? intl.get("modal_new_automation.event_params_info.deadline_activity.to_whatever_block") : intl.get("modal_new_automation.event_params_info.deadline_activity.to_block") + getValues("observedBlockId")?.label : ""))
            case "activity_finished":
                return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_finished"))
            case "activity_deleted":
                return fnSetCEventText(intl.get("modal_new_automation.notification_params.activity_deleted"))
            default:
                return fnSetCEventText("")
        }
    }, [watch("triggerType"), watch("repeatRange"), nStep])
    function fnGenerateTextEvent() {
        return (
            <>
                {getValues("triggerType")?.value !== "activity_moved" ? <p className={nStep === 3 ? styles.dataRender : ""}>{cEventText + " " + intl.get("modal_new_automation.event_params_info.deadline_activity.in_the_block") + " "}
                    {getValues("observedBlockId")?.label}, </p> : <p className={nStep === 3 ? styles.dataRender : ""}>{cEventText + " "}</p>}

                <span >{intl.get("modal_new_automation.event_params_info.deadline_activity.will_created")} </span>
                <p className={nStep === 3 ? styles.dataRender : ""}>{intl.get("modal_new_automation.event_params_info.deadline_activity.in_the_block")} {getValues("blockId")?.label}</p>
                {!getValues("notDeadLine") ? (
                    <>
                        <span >{intl.get("modal_new_automation.event_params_info.deadline_activity.deadline_execution")}</span>
                        {getValues("deadLineValue") && <p className={nStep === 3 ? styles.dataRender : ""}>{getValues("deadLineValue")} {getValues("deadLineRange").label}</p>}
                    </>
                ) : null}


            </>
        );
    }
    async function fnNextStep(e) {
        e.stopPropagation()
        e.preventDefault()
        nStep !== 3 && trigger()

        if (nStep + 1 <= aSteps.length && (await validateStep(0)) && nStep === 0) {
            fnSetNStep(nStep + 1)
            return
        }
        if (nStep + 1 <= aSteps.length && (await validateStep(1)) && nStep === 1) {
            if (!getValues("beginTime")) {
                setValue("beginTime", undefined)
            }
            if (!getValues("beginDate")) {
                setValue("beginDate", undefined)
            }
            if (!getValues("notDeadLine")) {
                setValue("notDeadLine", false)
            }
            fnSetNStep(nStep + 1)
            return
        }
        if (nStep + 1 <= aSteps.length && (await validateStep(2)) && nStep === 2) {
            cAutomationType !== "notification_trigger" && trigger(oSchemaFields._nodes) // Validation of fields
            fnSetNStep(3)
            return
        }
        if (nStep === 3) {
            fnFormatAutomationPaylod()

            return
        }
        return
    }


    function fnPrevStep(e) {
        e.stopPropagation()
        e.preventDefault()
        if (nStep - 1 >= 0) {
            fnSetNStep(nStep - 1)
            fnSetBIsDisabledButton(false)
            return
        }
        return
    }

    function submitForm(data) {
        if (nStep <= 3) return
        fnSetNStep(1)
        fnOnClose()
    }
    function fnCloseModal() {
        if (isDirty && !bIsEmptyForm && nStep !== 4) {
            fnSetBIsOpenModalInfo(true)
            return
        }
        fnSetNStep(1)
        fnSetAFieldsNewAutomation([])
        fnSetASettingForm([])
        fnOnClose()
    }
    return (
        <div >
            <Modal isOpen={bIsOpen} size="lg" >
                <Modal.Header onClose={fnCloseModal}>
                    {bIsEditAutomation && !bActiveAutomation ? intl.get("modal_new_form.edit_form", { form: oAutomationDataEdit.name }) : bShareAutomation ? intl.get("modal_new_automation.share_automation") : bActiveAutomation ? intl.get("modal_new_automation.active_automation").toUpperCase() : intl.get("modal_new_automation.new_automation")}
                </Modal.Header>
                <form
                    id="activity-form"
                    onSubmit={handleSubmit(submitForm)}
                >
                    <Modal.Content>
                        <FormProvider {...useFormMethods}>

                            <div className={styles.modalContent} ref={modalContainerRef} id="modalContent">
                                {getValues("automationName") && nStep > 0 && nStep < 4 && <div className={styles.automationNameContainer}>
                                    <Typography type="l2" color="#415364" >{intl.get("modal_new_automation.automatio_title")}:</Typography>
                                    <p>{getValues("automationName")}</p>
                                </div>}
                                {!bShareAutomation && nStep !== 4 && nStep !== 0 && <RcmpSteps aData={aSteps} nStep={nStep} />}

                                {nStep === 0 && <RcmpInitialStep bActiveAutomation={bActiveAutomation} nSetBIsDisabledButton={fnSetBIsDisabledButton} aBlocks={aBlocks} fnSetOblockSelected={fnSetOblockSelected} setValue={setValue} register={register} errors={errors} getValues={getValues} fnSetCAutomationType={fnSetCAutomationType} cAutomationType={cAutomationType} bIsEditAutomation={bIsEditAutomation} />}
                                {nStep !== 0 && getValues("automationType")?.value === "notification_trigger" && <RcmpAutomationNotification setValue={setValue} register={register} errors={errors} getValues={getValues} cUserTimezone={cUserTimezone} bDeadLineIsRequired={bDeadLineIsRequired} aBlocks={aBlocks} watch={watch} fnSetBIsDisabledButton={fnSetBIsDisabledButton} fnSetOblockSelected={fnSetOblockSelected} nStep={nStep} bIsEditAutomation={bIsEditAutomation} bActiveAutomation={bActiveAutomation}/>}

                                {nStep === 1 && getValues("automationType")?.value !== "notification_trigger" && <RcmpFirstStep fnSetBIsDisabledButton={fnSetBIsDisabledButton} aBlocks={aBlocks} fnSetOblockSelected={fnSetOblockSelected} setValue={setValue} register={register} errors={errors} getValues={getValues} aFields={aFieldsNewAutomation} cUserTimezone={cUserTimezone} bDeadLineIsRequired={bDeadLineIsRequired} watch={watch} cRecurrence={cRecurrence} fnSetCRecurrence={fnSetCRecurrence} reset={reset} nStep={nStep} bIsEditAutomation={bIsEditAutomation} setError={setError} clearErrors={clearErrors} fnGenerateTextEvent={fnGenerateTextEvent} bActiveAutomation={bActiveAutomation}/>}

                                {nStep === 2 && getValues("automationType")?.value !== "notification_trigger" && <RcmpSecondStep aFields={aFieldsNewAutomation} fnSetAFields={fnSetAFieldsNewAutomation} nStep={nStep} bIsOpen={bIsOpen} setValue={setValue} register={register} getValues={getValues} aSettingForm={aSettingForm} fnSetASettingForm={fnSetASettingForm} watch={watch} trigger={trigger} bIsEdit={bIsEditAutomation} cUserTimezone={cUserTimezone} fnFormatDate={fnFormatDate} fnSetCRecurrence={fnSetCRecurrence} cRecurrence={cRecurrence} fnGenerateTextEvent={fnGenerateTextEvent} />}

                                {nStep === 3 && getValues("automationType")?.value !== "notification_trigger" && < RcmpThirdtStep setValue={setValue} getValues={getValues} cUserTimezone={cUserTimezone} aFieldsNewAutomation={aFieldsNewAutomation} oUser={oUser} bIsOpenError={bIsOpenError} fnSetBIsOpenError={fnSetBIsOpenError} bIsEditAutomation={bIsEditAutomation} cRecurrence={cRecurrence} fnSetCRecurrence={fnSetCRecurrence} fnGenerateTextEvent={fnGenerateTextEvent} />}

                                {/* {nStep === 4 && getValues("automationType")?.value !== "notification_trigger" && < RcmpFourthtStep setValue={setValue} getValues={getValues} cUserTimezone={cUserTimezone} aFieldsNewAutomation={aFieldsNewAutomation} oUser={oUser} bIsOpenError={bIsOpenError} fnSetBIsOpenError={fnSetBIsOpenError} bIsEditAutomation={bIsEditAutomation} />} */}

                                {nStep === 4 && < RcmpFivetStep oNewAutomationRes={oNewAutomationRes} oUpdateAutomationRes={oUpdateAutomationRes} cust_id={oUser.data.cust_nid} bIsEditAutomation={bIsEditAutomation} bShareAutomation={bShareAutomation} oAutomation={oAutomation} />}
                            </div >

                        </FormProvider >
                    </Modal.Content >
                    <Modal.Footer>
                        <div className={styles.footerArea}>

                            {nStep !== 4 ?
                                (
                                    <>
                                        <Button type="button" variant="outline" onClick={fnCloseModal}>
                                            {intl.get("cancel")}

                                        </Button>
                                        <div className={styles.navigateButtons}>
                                            {nStep !== 0 && <Button
                                                iconLeft={<ArrowLeftIcon />}
                                                onClick={fnPrevStep}
                                            >
                                                {intl.get("back")}
                                            </Button>}
                                            <Button
                                                iconRight={nStep !== 3 && <ArrowRightIcon />}
                                                onClick={e => fnNextStep(e)}
                                                disabled={bDisabledButton}
                                                ref={buttonRef}
                                                type="button"
                                                isLoading={bIsLoading}
                                            >
                                                {nStep !== 3 ? intl.get("next") : !bIsEditAutomation ? intl.get("modal_new_automation.create_automation") : bActiveAutomation ? intl.get("modal_new_automation.active_automation").toUpperCase() : intl.get("modal_new_automation.edit_automation")}
                                            </Button>

                                        </div>
                                    </>
                                ) : (
                                    <div className={styles.doneForm}>
                                        <Button
                                            type="button"
                                            onClick={fnCloseModal}
                                        >
                                            {intl.get("modal_new_form.done")}
                                        </Button>
                                    </div>
                                )}
                        </div>
                    </Modal.Footer>
                </form >
            </Modal >
            <RcmpModalInfo
                bIsOpen={bIsOpenModalInfo}
                description={intl.get("modal_new_form.warning_text_form")}
                subText={intl.get("modal_new_form.warning_text_subText")}
                title={intl.get("cancel")}
                buttonCancelText={intl.get(
                    "activityModelModal.close_when_change_field_cancel"
                )}
                buttonSaveText={intl.get(
                    "activityModelModal.close_when_change_field_sure"
                )}
                size={"sm"}
                fnHandleConfirm={fnConfirmModalInfo}
                fnHandleCancel={fnCancelModalInfo}
            />

        </div >
    )
}
